import { accommodationSubTypeIdZodSchema } from "@@/shared/acquire/resources/resource-accommodation/accommodation-types/accommodation-sub-type-id";
import { accommodationTypeZodObject } from "@@/shared/acquire/resources/resource-accommodation/accommodation-types/accommodation-type";
import { resourceImageReferenceZodObject } from "@@/shared/acquire/resources/resource-accommodation/accommodation-types/resource-image-reference";
import { amenityZodObject } from "@@/shared/acquire/resources/resource-accommodation/amenities/amenity";
import { capacityZodObject } from "@@/shared/acquire/resources/resource-accommodation/capacity";
import {
    requiredTranslatableZodSchema,
    translatableZodSchema,
} from "@@/shared/translations/translation";
import { z } from "zod";

const resourceAccommodationDefinitionDataZodObject = z.object({
    // If you change this object make sure to
    // to update hasOverrides function as well
    // if needed.
    _type: z.literal("RESOURCE_ACCOMMODATION"),
    title: requiredTranslatableZodSchema,
    subtitle: translatableZodSchema.nullish(),
    description: translatableZodSchema.nullish(),
    imageRefs: z.array(resourceImageReferenceZodObject).nullish(),
    accommodationType: accommodationTypeZodObject.nullish(),
    amenities: z.array(amenityZodObject).nullish(), // TODO! Vill vi ha det såhär? object eller idn?
    capacity: capacityZodObject,
    disabledAccommodationSubTypeIds: z
        .array(accommodationSubTypeIdZodSchema)
        .nullish(),
    /** If `true` the resource can be checked in.
     * If `false` the resource can not be checked in.
     * If not set, it defaults to `false`. */
    checkInEnabled: z.coerce.boolean().nullish(),
    /** If `true` the resource allows unlimited number
     * of check ins to be true at once.
     * If `false` the resource can only be checked in
     * by one reservation at a time.
     * If not set, it defaults to `false`. */
    allowMultipleCheckIns: z.coerce.boolean().nullish(),
});

const hasOverrides = (data: ResourceAccommodationDefinitionData) => {
    return (
        !!data.subtitle ||
        !!data.description ||
        !!data.imageRefs ||
        !!data.accommodationType ||
        !!data.amenities ||
        !!data.disabledAccommodationSubTypeIds?.length ||
        data.disabledAccommodationSubTypeIds !== null ||
        data.allowMultipleCheckIns !== null ||
        data.checkInEnabled !== null ||
        Object.values(data.capacity).some(range => !!range)
    );
};

type ResourceAccommodationDefinitionData = z.infer<
    typeof resourceAccommodationDefinitionDataZodObject
>;

const _resourceAccommodationDefinitionFactoryParamsZodObject =
    resourceAccommodationDefinitionDataZodObject.omit({
        _type: true,
    });

type ResourceAccommodationDefinitionDataFactoryParams = z.infer<
    typeof _resourceAccommodationDefinitionFactoryParamsZodObject
>;

const resourceAccommodationDefinitionDataFactory = (
    params: ResourceAccommodationDefinitionDataFactoryParams,
): ResourceAccommodationDefinitionData => {
    return {
        ...params,
        _type: "RESOURCE_ACCOMMODATION",
    };
};

export {
    resourceAccommodationDefinitionDataFactory,
    resourceAccommodationDefinitionDataZodObject,
    hasOverrides as resourceAccommodationDefinitionHasOverrides,
};
export type {
    ResourceAccommodationDefinitionData,
    ResourceAccommodationDefinitionDataFactoryParams,
};
